import React, { useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import PickListItem from './PickListItem';
import Flex from '../containers/Flex';
import AutoFlex from '../containers/AutoFlex';
import Spacer from '../Spacer';
import { border } from '../styles';
import { normaliseData } from './pickListCommon';

const h4Style = {
    margin: 0,
    padding: '0 20px',
    color: '#414141',
    fontSize: 15,
    fontWeight: 500,
    fontFamily: 'roboto'
};

const PickList = forwardRef(
    (
        {
            types,
            maxItems,
            data,
            setData,
            readOnlyCount = 0,
            style,
            headerStyle,
            keyToDisplay
        },
        ref
    ) => {
        maxItems = maxItems ?? data.length;
        style = {
            boxSizing: 'border-box',
            listStyleType: 'none',
            padding: 0,
            textAlign: 'left',
            margin: 0,
            backgroundColor: '#ffffff',
            ...style
        };
        useEffect(() => {
            setData(normaliseData(types, data, maxItems));
        }, [maxItems, data.length, setData]);

        const handleOrderChange = (targetIndex, draggedIndex) => {
            const mutar = [...data];
            const option = mutar[targetIndex];
            mutar[targetIndex] = mutar[draggedIndex];
            mutar[draggedIndex] = option;
            setData(mutar);
        };

        return (
            <ol ref={ref} id='pick-list' style={style}>
                <li
                    id='pick-list-headings-row'
                    style={{
                        boxSizing: 'border-box',
                        height: 27,
                        borderBottom: border,
                        ...headerStyle
                    }}
                >
                    <Flex id='pick-list-headings'>
                        <Spacer width={30} />
                        <AutoFlex>
                            {types.map((v, k) => (
                                <Flex
                                    key={k}
                                    id='pick-list-header-container'
                                    spaceBetween
                                    style={{ width: '100%' }}
                                >
                                    <h4
                                        id={`pick-list-values-heading-${k}`}
                                        style={h4Style}
                                    >
                                        Values
                                    </h4>
                                    {k === types.length - 1 &&
                                        readOnlyCount > 0 && (
                                            <h4
                                                id='pick-list-mandatory-values-label'
                                                style={{
                                                    ...h4Style,
                                                    color: '#919191'
                                                }}
                                            >
                                                * Mandatory values
                                            </h4>
                                        )}
                                </Flex>
                            ))}
                        </AutoFlex>
                    </Flex>
                </li>
                {data.map((o, i) => (
                    <PickListItem
                        key={i}
                        index={i}
                        types={types}
                        values={o.values}
                        readOnly={o.readOnly}
                        data={data}
                        setData={setData}
                        onOrderChange={handleOrderChange}
                        keyToDisplay={keyToDisplay}
                    />
                ))}
            </ol>
        );
    }
);

PickList.displayName = 'PickList';

PickList.defaultProps = {
    minItems: 1
};

PickList.propTypes = {
    types: PropTypes.arrayOf(PropTypes.oneOf(['text', 'number', 'currency']))
        .isRequired,
    maxItems: PropTypes.number,
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    setData: PropTypes.func,
    style: PropTypes.object,
    headerStyle: PropTypes.object
};

export default PickList;
